
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/companies/[slug]",
      function () {
        return require("private-next-pages/companies/[slug]/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/companies/[slug]"])
      });
    }
  